import React from 'react';
import {Btn, FlexDiv, FlexRowSection, GreyText} from "../../../styles/globalStyles";
import {t} from 'i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import dayjs from "dayjs";
import {useSelector} from "react-redux";
import {light} from '@fortawesome/fontawesome-svg-core/import.macro';
import SummaryCard from "../../../components/SummaryCard";
import {getRequestDateLabel, getRequestTimeRangeLabel} from "./WaitlistHelpers";

const JoinWaitlistSummary = (props) => {
    const { values, errors, onCTAClick, coaches, coach_name, showAllRange } = props;
    const flags = useSelector(state => state.stepper.flags)

    const getSummaryRows = () => {
        const coachName = values.coach_ub_id === null ? t('appointment-waitlist-any-coach') : (coach_name ?? coaches?.find(coach => coach.id === values.coach_ub_id)?.full_name)
        let dates = getRequestDateLabel(values)
        let times = getRequestTimeRangeLabel(values, showAllRange)
        return [
            {label: t('appointment-waitlist-summary-service'), value: flags.service?.name ?? ''},
            {label: t('appointment-waitlist-summary-coach'), value: coachName},
            {label: t('appointment-waitlist-summary-date'), value: dates},
            {label: t('appointment-waitlist-summary-time'), value: <>{times}{!showAllRange && values.timeRange?.length > 1 && <GreyText as={'span'} fontSize={'15px'}> +{values.timeRange?.length - 1}</GreyText>}</>},
        ]
    }

    return (
        <SummaryCard
            title={t('appointment-waitlist-summary-title')}
            rows={getSummaryRows()}
            footer={onCTAClick &&
                <FlexDiv gap={'8px'} padding={'0 20px 20px'}>
                    <Btn type={'primary'} width={'100%'} onClick={onCTAClick} disabled={Object.keys(errors)?.length > 0}>
                        <FlexRowSection gap={'8px'} flex={'unset'} justify={'center'}>
                            <FontAwesomeIcon icon={light('bell')}/>
                            <span>{t('appointment-waitlist-join-button')}</span>
                        </FlexRowSection>
                    </Btn>
                    {(!values.from || !values.to) && <GreyText style={{alignSelf: 'center'}}>{t('select-date-helper')}</GreyText>}
                </FlexDiv>
            }
        />
    );
};

export default JoinWaitlistSummary;
